import { Link } from 'react-router-dom';

export const LInk = ({ ...props }) => {
  if(props.redirect){
      return <a href={props.to} {...props}>{props.children}</a>
  }
  return (
    <Link {...props}>{props.children}</Link>
  );
}

